import React from "react";
import {
  RATE_POLICIES,
  RATE_MODES,
} from "../../../../constants/branch.constants";

const BranchRateConfig = ({
  formData,
  updateField,
  updateNestedField,
  branches,
}) => {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Rate Policy
          </label>
          <select
            value={formData.rateConfig.ratePolicy}
            onChange={(e) =>
              updateNestedField(
                "rateConfig",
                null,
                "ratePolicy",
                e.target.value
              )
            }
            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
          >
            {Object.entries(RATE_POLICIES).map(([key, label]) => (
              <option key={key} value={key}>
                {label}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Rate Mode
          </label>
          <select
            value={formData.rateConfig.rateMode}
            onChange={(e) =>
              updateNestedField("rateConfig", null, "rateMode", e.target.value)
            }
            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
          >
            {Object.entries(RATE_MODES).map(([key, label]) => (
              <option key={key} value={key}>
                {label}
              </option>
            ))}
          </select>
        </div>

        {formData.rateConfig.ratePolicy === "INHERIT" && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Inherit From Branch
            </label>
            <select
              value={formData.rateConfig.inheritFromBranch}
              onChange={(e) =>
                updateNestedField(
                  "rateConfig",
                  null,
                  "inheritFromBranch",
                  e.target.value
                )
              }
              className="w-full px-3 py-2 border border-gray-300 rounded-lg"
            >
              <option value="">Select Branch</option>
              {branches
                .filter((b) => b.isMainBranch || b.parentBranchId === null)
                .map((branch) => (
                  <option key={branch._id} value={branch._id}>
                    {branch.name} ({branch.code})
                  </option>
                ))}
            </select>
          </div>
        )}
      </div>

      <div className="bg-gray-50 p-4 rounded-lg">
        <h4 className="font-semibold mb-3">Location Adjustments</h4>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Transport (₹/gm)
            </label>
            <input
              type="number"
              step="0.01"
              value={formData.rateConfig.adjustments.transport}
              onChange={(e) =>
                updateNestedField(
                  "rateConfig",
                  "adjustments",
                  "transport",
                  parseFloat(e.target.value) || 0
                )
              }
              className="w-full px-3 py-2 border border-gray-300 rounded-lg"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Operational (₹/gm)
            </label>
            <input
              type="number"
              step="0.01"
              value={formData.rateConfig.adjustments.operational}
              onChange={(e) =>
                updateNestedField(
                  "rateConfig",
                  "adjustments",
                  "operational",
                  parseFloat(e.target.value) || 0
                )
              }
              className="w-full px-3 py-2 border border-gray-300 rounded-lg"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Rent (₹/gm)
            </label>
            <input
              type="number"
              step="0.01"
              value={formData.rateConfig.adjustments.rent}
              onChange={(e) =>
                updateNestedField(
                  "rateConfig",
                  "adjustments",
                  "rent",
                  parseFloat(e.target.value) || 0
                )
              }
              className="w-full px-3 py-2 border border-gray-300 rounded-lg"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Margin (%)
            </label>
            <input
              type="number"
              step="0.1"
              value={formData.rateConfig.adjustments.margin}
              onChange={(e) =>
                updateNestedField(
                  "rateConfig",
                  "adjustments",
                  "margin",
                  parseFloat(e.target.value) || 0
                )
              }
              className="w-full px-3 py-2 border border-gray-300 rounded-lg"
            />
          </div>
        </div>
      </div>

      <div className="bg-blue-50 p-4 rounded-lg">
        <p className="text-sm text-gray-600">
          For detailed margin overrides and advanced configuration, use the Rate
          Configuration section in the branch details view after saving.
        </p>
      </div>
    </div>
  );
};

export default BranchRateConfig;
